import { render, staticRenderFns } from "./InvestorPageSlider.vue?vue&type=template&id=2a70e682&scoped=true&"
import script from "./InvestorPageSlider.vue?vue&type=script&lang=js&"
export * from "./InvestorPageSlider.vue?vue&type=script&lang=js&"
import style0 from "./InvestorPageSlider.vue?vue&type=style&index=0&id=2a70e682&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a70e682",
  null
  
)

export default component.exports